import { AuthorResponseModel } from "@models/users";
import { AnimatePresence } from "framer-motion";
import OneAuthor from "./OneAuthor";
import { useState } from "react";
import React from "react";
import Title from "@components/common/Title";
import Button from "@components/common/Button";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { twMerge } from "tailwind-merge";

export interface AuthorWrapperPropsModel {
  authors: AuthorResponseModel[] | undefined;
  speakerWriterHeader: string;
}
const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
};
const AuthorWrapper: React.FunctionComponent<AuthorWrapperPropsModel> = ({
  authors,
  speakerWriterHeader,
}) => {
  const [[page, direction], setPage] = useState([0, 0]);
  const dataLength = authors?.length ?? 0;
  const dataIndex = page % dataLength;
  const selectedData = authors?.[dataIndex];
  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };
  const dynamicClassName = "";
  // const dynamicClassName =
  //   authors && authors?.length > 1 ? "min-h-[330px]" : "min-h-[250px]";
  const renderAuthorCount = () => {
    let textStr = speakerWriterHeader;
    if (dataLength > 3) {
      textStr = `3+ ${speakerWriterHeader}s`;
    } else if (dataLength == 2) {
      textStr = `2 ${speakerWriterHeader}s`;
    }
    return (
      <div className="flex items-center">
        <div className="h-4 pr-2 border-l">&nbsp;</div>
        <Title variant="paragraph" titleText={textStr} className="text-left" />
      </div>
    );
  };
  const renderBtnAndAutorCount = () => {
    if (authors && authors?.length > 1) {
      return (
        <div className="flex justify-between mb-[22px]">
          {renderAuthorCount()}
          <div className="flex gap-3">
            <Button
              variant="carousel"
              onClick={() => paginate(-1)}
              className="h-6 w-6 xl:h-8 xl:w-8 p-0 bg-primary-blue-50 text-white"
              disabled={page === 0}
            >
              <AiOutlineArrowLeft size={18} />
            </Button>
            <Button
              variant="carousel"
              onClick={() => paginate(1)}
              className="h-6 w-6 p-0 xl:h-8 xl:w-8 bg-primary-blue-50 text-white"
              disabled={page === authors?.length - 1}
            >
              <AiOutlineArrowRight />
            </Button>
          </div>
        </div>
      );
    }
  };

  if (!authors?.length) return <></>;

  return (
    <div
      className={twMerge(
        "max-w-[680px] p-10 rounded-2xl overflow-hidden basis-1/2 h-max mt-12  md:mt-0",
        dynamicClassName
      )}
      style={{ backgroundColor: " #F1FCFF" }}
    >
      {renderBtnAndAutorCount()}
      <AnimatePresence initial={false} custom={direction}>
        <OneAuthor
          data={{
            author: selectedData,
            direction: direction,
            variants: variants,
          }}
        />
      </AnimatePresence>
    </div>
  );
};

export default AuthorWrapper;
